import React, { useEffect, useRef, useState } from 'react';
import {
  isMobile,
  freeBetStore,
  useTranslation,
  gameConfigStore,
  abbreviateNumber,
  HorizontalScroll,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';

import { doBetsStore } from '../../../store';
import { soundService, soundTypes } from '../../../services';

const sectionJumpSize = 90;
let scrollLeft = 0;
let savedBetAmount = 0;

export const BetAmountSection = observer(() => {
  const { isBetBlocksClickable, setIsRequiredRedrawGame, setBetAmount, betAmount } = doBetsStore;
  const { activeFreeBet } = freeBetStore;
  const { limits } = gameConfigStore;
  const [isScrolling, setIsScrolling] = useState(false);
  const fixBets = useRef();
  const [quickBets, setQuickBets] = useState(limits?.quickBets || []);

  useEffect(() => {
    setQuickBets(limits?.quickBets || []);
  }, [limits]);

  useEffect(() => {
    if (activeFreeBet?.id) {
      setBetAmount(activeFreeBet.amount);
    } else {
      setBetAmount(betAmount ? betAmount : isMobile() ? quickBets[0] : quickBets[2]);
      savedBetAmount = doBetsStore.betAmount;
    }
  }, [quickBets]);

  useEffect(() => {
    if (activeFreeBet?.id) {
      setBetAmount(activeFreeBet.amount);
    } else {
      setBetAmount(savedBetAmount ? savedBetAmount : isMobile() ? quickBets[0] : quickBets[2]);
    }
  }, [activeFreeBet]);

  useEffect(() => {
    if (fixBets.current) {
      fixBets.current.scrollLeft = scrollLeft;
    }
  }, [activeFreeBet]);

  const scrollSectionLeft = () => {
    fixBets.current.scrollLeft -= sectionJumpSize;
    soundService.play(soundTypes.click);
  };

  const scrollSectionRight = () => {
    fixBets.current.scrollLeft += sectionJumpSize;
    soundService.play(soundTypes.click);
  };

  const getBetAmount = (amountValue) => {
    if (!isScrolling) {
      scrollLeft = fixBets.current.scrollLeft;
      setBetAmount(amountValue);
      savedBetAmount = amountValue;
      soundService.play(soundTypes.click);
      setIsRequiredRedrawGame(true);
    }
  };

  if (activeFreeBet.id) {
    return <FreeBetAmountSection amount={activeFreeBet.amount} />;
  } else {
    return (
      <div className='bet-view' dir='ltr'>
        <div
          className={`bet-view-content ${isBetBlocksClickable ? '' : 'disabled'} ${activeFreeBet.id ? 'disabled' : ''}`}
        >
          <div className='bet-view-content-icon left' onClick={scrollSectionLeft}>
            <i className='ui-lib-expand_more_black_24dp' />
          </div>
          <div className='bet-view-content-inner'>
            <HorizontalScroll
              additionalClassNames={'bet-view-content-inner'}
              additionalRef={fixBets}
              setIsScrollingFalse={() => {
                setTimeout(() => {
                  setIsScrolling(false);
                }, 0);
              }}
              onMouseUpAdditionalFunction={() => setIsScrolling(false)}
              onMouseDownAdditionalFunction={() => setIsScrolling(true)}
              onMouseMoveAdditionalFunction={() => setIsScrolling(true)}
            >
              {quickBets.map((value, i) => (
                <div
                  key={`${i}${value}`}
                  className={`bet-row ${betAmount === value  ? 'active' : ''}`}
                  onClick={() => getBetAmount(value)}
                >
                  <span className='bet-row-currency'>
                    {abbreviateNumber(value)}
                    <span />
                  </span>
                  <span className='bg' />
                </div>
              ))}
            </HorizontalScroll>
          </div>
          <div className='bet-view-content-icon right' onClick={scrollSectionRight}>
            <i className='ui-lib-expand_more_black_-1' />
          </div>
        </div>
      </div>
    );
  }
});

const FreeBetAmountSection = observer(({ amount }) => {
  const t = useTranslation();
  return (
    <div className='fast-trade-free-bet-btn'>
      <div className='fast-trade-free-bet'>
        <p className='fast-trade-free-bet-title'>{t('FREE_BET')} {freeBetStore.activeFreeBet?.remainingCount}</p>
        {/*<i className='gift' />*/}
      </div>
      <div className='fast-trade-amount'>
        <span>{amount}</span>
      </div>
    </div>
  );
});
